require('./modules/global.js');
require('./modules/modal.js');
require('./modules/header.js');
require('./modules/carousel.js');
